<template>
  <div>
    <Header
      :show="true"
      title="审核加油申请"
      left="prepage"
      :click-left="clickLeft"
    />
    <div style="padding-bottom: 8vh">
      <div>
        <van-field
          v-model.trim="listQuery.vehicleNo"
          label="车牌号"
          placeholder="请输入"
        />
        <van-field
          :value="getCheckValue(listQuery.checkStatus).name || ''"
          label="审核状态"
          placeholder="请选择审核状态"
          clickable
          readonly
          is-link
          @click="showstatuspicker = true"
        />
        <van-action-sheet
          v-model="showstatuspicker"
          :actions="refuelCheckList"
          cancel-text="取消"
          description="选择审核状态"
          @select="onCheckStatusSelect"
        />
        <van-field
          :value="getStatusValue(listQuery.refuelStatus).name || ''"
          label="加油状态"
          placeholder="请选择加油状态"
          clickable
          readonly
          is-link
          @click="showrefuelstatuspicker = true"
        />
        <van-action-sheet
          v-model="showrefuelstatuspicker"
          :actions="refuelStatusList"
          cancel-text="取消"
          description="选择加油状态"
          @select="onRefuelStatusSelect"
        />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="info"
            @click="getListData"
          >
            查询
          </van-button>
        </div>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              :show-message="false"
              style="padding: 0 20px"
              class="tableExpressInfo"
            >
              <el-form-item label="车辆名称">
                <span>{{ row.vehicleName }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.vehicleNo }}</span>
              </el-form-item>
              <el-form-item label="加油类型">
                <span>{{ getRefuelValue(row.refuelTypeCode).name || "" }}</span>
              </el-form-item>
              <el-form-item label="申请加油量">
                <span>{{ row.applyRefuelCap }}</span>
              </el-form-item>
              <el-form-item label="申请人">
                <span>{{ getStaffInfo(row.applyUserId).name || "" }}</span>
              </el-form-item>
              <el-form-item label="审核时间">
                <span>{{ row.checkTime | formatDate }}</span>
              </el-form-item>
              <el-form-item label="加油时间">
                <span>{{ row.refuelTime | formatDate }}</span>
              </el-form-item>
              <van-row gutter="16">
                <van-col>
                  <el-button
                    v-if="checkPermission([425])"
                    :disabled="row.checkStatus !== 0"
                    type="primary"
                    size="mini"
                    @click="handleCheck(row, 'check')"
                  >
                    审核申请
                  </el-button>
                </van-col>
                <van-col>
                  <el-button
                    v-if="checkPermission([427])"
                    :disabled="
                      !row.isSkipVfVerify ||
                        (row.isSkipVfVerify && row.skipVerifyCheckStatus !== 0)
                    "
                    type="warning"
                    size="mini"
                    @click="handleCheck(row, 'skip')"
                  >
                    审核跳过验证
                  </el-button>
                </van-col>
              </van-row>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="车牌号"
          prop="vehicleNo"
          width="100px"
        />
        <el-table-column
          label="加油量"
          prop="applyRefuelCap"
          width="80"
          show-overflow-tooltip
        />
        <el-table-column
          label="审核状态"
          prop="checkStatus"
          width="80"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.checkStatus === 0"
              type="warning"
            >
              {{ getCheckValue(row.checkStatus).name || "" }}
            </el-tag>
            <el-tag
              v-if="row.checkStatus === 1"
              type="primary"
            >
              {{ getCheckValue(row.checkStatus).name || "" }}
            </el-tag>
            <el-tag
              v-if="row.checkStatus === -1"
              type="danger"
            >
              {{ getCheckValue(row.checkStatus).name || "" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="加油状态"
          prop="refuelStatus"
          width="80"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.refuelStatus === 0"
              type="info"
            >
              {{ getStatusValue(row.refuelStatus).name || "" }}
            </el-tag>
            <el-tag
              v-if="row.refuelStatus === 1"
              type="primary"
            >
              {{ getStatusValue(row.refuelStatus).name || "" }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="getListData"
      />
    </div>
    <Footer value="service" />

    <CheckApply
      :visible.sync="showCheck"
      :type="showCheckType"
      :default-value="showCheckData"
      @success="onCheckSuccess"
    />
  </div>
</template>

<script>
import { getDictOne } from "@/api/dict";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import CheckApply from "./CheckApply.vue";

import checkPermission from "@/utils/permission";

import { showPhoneAlarm } from "@/global/function.js";
import { getList } from "@/api/vehicle";
import { getList as getStaffList } from "@/api/staff.js";

import dayjs from "dayjs";

const listQuery = {
  page: 1,
  limit: 10,
  vehicleNo: undefined,
  checkStatus: "0",
  refuelStatus: "",
  applyId: undefined,
};

const table = {
  listLoading: false,
  fullWidth: document.documentElement.clientWidth,
  key: 0,
  total: 0,
  data: [],
};

const components = { Header, Footer, CheckApply };
const basicMethods = {
  checkPermission,
  clickLeft() {
    this.$router.go(-1);
  },
  async getCheckStatus() {
    const dicts = await getDictOne({ type: "refuelcheck" });
    dicts.unshift({ label: "全部状态", value: "" });
    this.refuelCheckList = dicts.map((dict) => ({
      name: dict.label,
      value: dict.value,
    }));
  },
  async getRefuelStatus() {
    const dicts = await getDictOne({ type: "refuelstatus" });
    dicts.unshift({ label: "全部状态", value: "" });
    this.refuelStatusList = dicts.map((dict) => ({
      name: dict.label,
      value: dict.value,
    }));
  },
  async getRefuelType() {
    const dicts = await getDictOne({ type: "refueltype" });
    this.refuelTypeList = dicts.map((dict) => ({
      name: dict.label,
      value: dict.code,
    }));
  },
  getCheckValue(value) {
    return (
      this.refuelCheckList.find((refuel) => refuel.value === "" + value) || {}
    );
  },
  getStatusValue(value) {
    return (
      this.refuelStatusList.find((status) => status.value === "" + value) || {}
    );
  },
  getRefuelValue(code) {
    return this.refuelTypeList.find((type) => type.value === code) || {};
  },
  async getStaffList() {
    const { data: staff } = await getStaffList({
      page: 1,
      limit: 10000,
    });
    const { data } = staff;
    this.staffList = data?.items || [];
  },
  getStaffInfo(id) {
    return this.staffList.find((staff) => staff.id === +id) || {};
  },
};

const checkMethod = {
  onCheckStatusSelect({ value }) {
    this.listQuery.checkStatus = value;
    this.showstatuspicker = false;
  },
  onRefuelStatusSelect({ value }) {
    this.listQuery.refuelStatus = value;
    this.showrefuelstatuspicker = false;
  },
};

const formatMethod = {
  formatDate: function (date) {
    if (!date) return date;
    return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
  },
};

const applyCheck = {
  data: {
    showCheck: false,
    showCheckType: "check",
    showCheckData: {},
  },
  method: {
    handleCheck(data, type) {
      this.showCheck = true;
      this.showCheckType = type;
      this.showCheckData = data;
    },
    onCheckSuccess() {
      this.showCheck = false;
      this.getListData();
    },
  },
};
export default {
  filters: {
    ...formatMethod,
  },
  components,
  data() {
    return {
      listQuery,
      table,
      ...applyCheck.data,
      refuelCheckList: [],
      refuelStatusList: [],
      refuelTypeList: [],
      showstatuspicker: false,
      showrefuelstatuspicker: false,
      staffList: [],
    };
  },
  mounted() {
    this.listQuery.applyId = this.$route.query.applyId;
    this.$nextTick(() => this.getListData());
  },
  created() {
    this.getCheckStatus();
    this.getRefuelStatus();
    this.getRefuelType();
    this.getStaffList();
  },
  methods: {
    ...basicMethods,
    ...checkMethod,
    ...applyCheck.method,
    handleTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    async getListData() {
      const payload = {
        page: {
          current: this.listQuery.page,
          size: this.listQuery.limit,
        },
        where: {
          "lk_apply.vehicleNo": this.listQuery.vehicleNo || undefined,
          "eq_apply.checkStatus": this.listQuery.checkStatus,
          "eq_apply.refuelStatus": this.listQuery.refuelStatus || undefined,
          "desc_apply.createTime": "1",
        },
      };
      if (this.listQuery.applyId) {
        payload.where = {
          "eq_apply.id": this.listQuery.applyId,
        };
        this.listQuery.applyId = undefined;
      }
      const response = await getList(payload).catch(() => false);
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            false,
            "toast",
            null,
            2000,
            data.code,
            null,
            data.message
          )
        ) {
          this.table.total = data.page.total;
          this.table.data = data.page.records;
        }
      }
    },
  },
};
</script>
<style>
.tableExpressInfo .el-form-item {
  margin-bottom: 0 !important;
}
</style>